/** A mic's volume as a meter's fill, 0 to 1. */
export const volumeToLevel = (volume: number) => Math.round(Math.min(1, volume * 20) * 100) / 100;
